import axiosInstance from '../axiosInterceptor/axiosInstance'

const stopLivestream = async (broadcastId, orgId) => {
  const url = `v1/orgs/${orgId}/streams/${broadcastId}/stop`
  return axiosInstance.post(url, {})
}

export default stopLivestream
